export var source_documentation_search = { "uid": "source_documentation_search", "fields": { "title": { "defaultValue": "" }, "no_results_title": { "defaultValue": "" }, "no_results_tips": { "defaultValue": "" } } };
